// extracted by mini-css-extract-plugin
module.exports = {"blockquote":"pullquote-module--blockquote--3uJvi","score":"pullquote-module--score--1_ZCY"};